import { createTheme } from "@mui/material";

export const theme = createTheme({
  components: {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: "var(--white)",
            backgroundColor: "var(--blue)",
            transition: "color 0.1s",
            "&:hover": {
              backgroundColor: "#759aff",
              color: "white",
              transition: "color 0s",
            },
          },
          "&:hover": {
            backgroundColor: "#759aff",
            color: "white",
            transition: "color 0s",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "7px",
          boxShadow:
            "rgba(145, 158, 171, 0.3) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px",
          "&:focus": {
            outline: "none",
          },
        },
      },
      defaultProps: {
        elevation: 0,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          outline: "none",
          minWidth: "auto",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          padding: "0px",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          transition: "none",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          transition: "all 0ms",
          padding: "4px",
        },
        popper: {
          transition: "all 0ms",
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: "0px",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "16px",
          paddingLeft: "0",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "22px",
          width: "22px",
          height: "22px",
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&.MuiTab-root.Mui-selected": {
            backgroundColor: "var(--blue)",
            color: "white",
            borderRadius: "7px 7px 0 0",
            padding: "12.5px",
            textTransform: "none",
            minHeight: "fit-content",
          },
          "&.MuiTab-root": {
            padding: "12.5px",
            textTransform: "none",
            minHeight: "fit-content",
            color: "var(--black)",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          // Change styles for the AppBar
          backgroundColor: "white", // Change the background color
          borderRadius: "0px",
          color: "var(--black)",
          boxShadow: "none",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "white", // Change the background color
          borderRadius: "0px",
          color: "var(--black)",
          padding: "0px",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: "7px",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          padding: "0px",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
  },
  palette: {
    primary: {
      light: "#f5faff",
      main: "#1a73e8",
      dark: "#01346b",
      contrastText: "#FFF",
    },
  },
  typography: {
    fontFamily: "Barlow, sans-serif",
    h1: {
      fontSize: "1.125rem",
      fontWeight: "1.6rem",
    },
    body1: {
      fontSize: "0.925rem",
    },
  },
  custom: {
    colors: {
      gray: "#e3e3e3",
    },
    space: "24px",
  },
});
